import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from '../header/header.component';

@Component({
    selector: 'web-nav-container',
    templateUrl: './nav-container.component.html',
    styleUrls: ['./nav-container.component.scss'],
    imports: [IonicModule, HeaderComponent],
})
export class NavContainerComponent {
    @Input() title?: string;
    @Input() icon?: string;
    @Input() loader = false;
    @Input() iconColor?: 'primary' | 'light' | 'dark' = 'primary';
    @Input() displayIcon = true;
    @Input() background = false;
    @Input() disabled = false;

    @Output()
    action: EventEmitter<void> = new EventEmitter();

    triggerAction() {
        this.action.emit();
    }
}
